import React from "react"

const ServicesSection = () => {
  return (
    <section id="services-section">
      <div className="container">
        <div className="row">
          <div className="col-12 about-pb">
            <div className="section-header">
              <h2 className="section-head-title m-0">Our Services</h2>
            </div>
            <p className="lead text-center">
              We love what we do and we do what our clients love & work with
              great clients
              <br />
              all over the world to create thoughtful and purposeful websites.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6">
            <div className="media services-wrap ">
              <div className="pull-left">
                <img
                  className="img-responsive"
                  src={require("../../../static/images/services/web-development.svg")}
                />
              </div>
              <div className="media-body">
                <h3 className="media-heading">Web Development</h3>
                <p>We develope professional websites for our clients.</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="media services-wrap ">
              <div className="pull-left">
                <img
                  className="img-responsive"
                  src={require("../../../static/images/services/web-designing.svg")}
                />
              </div>
              <div className="media-body">
                <h3 className="media-heading">Web Designing</h3>
                <p>We design professional looking websites.</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="media services-wrap ">
              <div className="pull-left">
                <img
                  className="img-responsive"
                  src={require("../../../static/images/services/web-applications.svg")}
                />
              </div>
              <div className="media-body">
                <h3 className="media-heading">Web Applications</h3>
                <p>We build professional web applications.</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="media services-wrap ">
              <div className="pull-left">
                <img
                  className="img-responsive"
                  src={require("../../../static/images/services/graphic-designing.svg")}
                />
              </div>
              <div className="media-body">
                <h3 className="media-heading">Graphic Designing</h3>
                <p>Graphic Designing is one of our core service.</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="media services-wrap ">
              <div className="pull-left">
                <img
                  className="img-responsive"
                  src={require("../../../static/images/services/mobile-applications.svg")}
                />
              </div>
              <div className="media-body">
                <h3 className="media-heading">Mobile Applications</h3>
                <p>We are highly efficient in developing Mobile Apps.</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="media services-wrap">
              <div className="pull-left">
                <img
                  className="img-responsive"
                  src={require("../../../static/images/services/seo-marketing.svg")}
                />
              </div>
              <div className="media-body">
                <h3 className="media-heading">SEO Marketing</h3>
                <p>We do SEO for better Marketing for our clients.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ServicesSection
